import { createClient } from "@supabase/supabase-js";

/**
 * Frontend Supabase client — uses the anon key (safe for browser).
 * Used for Auth operations only (signInWithOtp, signInWithPassword, etc).
 * All data operations go through apiFetch() → backend API.
 *
 * Session config: sessions persist for up to 7 days until manual logout.
 * The SDK auto-refreshes the JWT access token using the long-lived refresh token.
 * Supabase project must have JWT expiry ≥ 604800s (7 days) and refresh token
 * reuse set to at least 7 days in the Auth → Sessions settings.
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn("⚠ VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set — auth will fail.");
}

/** Session persists for 7 days (604 800 seconds) — users stay logged in until they sign out. */
export const SESSION_DURATION_SECONDS = 7 * 24 * 60 * 60; // 604 800

export const supabase = createClient(SUPABASE_URL || "https://placeholder.supabase.co", SUPABASE_ANON_KEY || "placeholder", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "qm-auth-token",
  },
});
